import api from ".";
import { getToken } from "../Auth/Token";

export const getSuppliers = async (query = "") => {
  try {
    const token = getToken();
    const params = {};
    if (query) params.q = query;

    const res = await api.get("/api/suppliers", {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return res.data;
  } catch (error) {
    console.error("Get Suppliers API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const syncSuppliersFromErpag = async () => {
  try {
    const token = getToken();
    const res = await api.post(
      "/api/suppliers/sync",
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return res.data;
  } catch (error) {
    console.error("Sync Suppliers API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const uploadSuppliersExcel = async (file, token) => {
  try {
    const authToken = token || getToken();
    const formData = new FormData();
    formData.append("file", file);

    const res = await api.post("/api/suppliers/upload", formData, {
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return res.data;
  } catch (error) {
    console.error("Upload Suppliers API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const createSupplier = async (payload) => {
  try {
    const token = getToken();
    const res = await api.post("/api/suppliers", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return res.data;
  } catch (error) {
    console.error("Create Supplier API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

const getFilenameFromDisposition = (contentDisposition, fallbackName) => {
  const value = String(contentDisposition || "");
  const utf8Match = value.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1]).replace(/["']/g, "");
  }
  const filenameMatch = value.match(/filename="?([^"]+)"?/i);
  if (filenameMatch?.[1]) {
    return filenameMatch[1];
  }
  return fallbackName;
};

export const downloadSuppliersExcel = async () => {
  try {
    const token = getToken();
    const res = await api.get("/api/suppliers/export", {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const filename = getFilenameFromDisposition(
      res.headers?.["content-disposition"],
      `suppliers-${new Date().toISOString().slice(0, 10)}.xlsx`,
    );

    return {
      blob: res.data,
      filename,
    };
  } catch (error) {
    console.error("Download Suppliers Excel API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};
